import { createReducer } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  error: null,
};

export const assetsReducer = createReducer(initialState, (builder) => {
  builder
    .addCase("GET_ALL_ASSETS_REQUEST", (state) => {
      state.loading = true;
    })
    .addCase("GET_ALL_ASSETS_SUCCESS", (state, action) => {
      state.loading = false;
      state.assets = action.payload.assets;
      state.count = action.payload.count;
    })
    .addCase("GET_ALL_ASSETS_ERROR", (state, action) => {
      state.loading = false;
      state.error = action;
    });
});
